// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"40fe4fea","116":"ac94c24c","259":"efe8bc99","336":"ea1a2089","342":"28293aa1","465":"43199b53","479":"56b7be65","640":"07654d58","658":"78b7477a","682":"824d4de1","865":"5906bf5d","937":"ac194fcd","975":"68211019"}[chunkId] + ".chunk.js";
};